<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row-start row-space">
            
            <div class="form-item-char30">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item-rangedata"><DateRangeSelect v-model="dateRange" /></div>
            
            <OsStatusSelect class="form-item" v-model:statusSelecionado="idStatus1" />
            <OsStatusSelect class="form-item" v-model:statusSelecionado="idStatus2" />

            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <div class="row row-space">
            <EquipamentoGrupoSelect :ckAddTodos="true" v-model:idSelecionado="idGrupo" />
            <EquipamentoSelect :ckAddTodos="true" :flagTipo="1" v-model:idSelecionado="idEquipamento" />
        </div>

        <div class="row row-space">
            <RegiaoSelect :ckAddTodos="true" v-model:idSelecionado="idRegiao" />
            <LocalidadeSelect :ckAddTodos="true" v-model:idSelecionado="idLocalidade" />
            <ServicoSelect :ckAddTodos="true" v-model:idSelecionado="idServico" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EquipamentoGrupoSelect from '@/selects/EquipamentoGrupoSelect.vue';
import EquipamentoSelect from '@/selects/EquipamentoSelect.vue';
import LocalidadeSelect from '@/selects/LocalidadeSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import OsStatusSelect from '@/selects/estaticos/OsStatusSelect.vue';
import RegiaoSelect from '@/selects/RegiaoSelect.vue';
import ServicoSelect from '@/selects/ServicoSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const idEquipamento = ref(null);
const idGrupo = ref(null);
const idLocalidade = ref(null);
const idRegiao = ref(null);
const idServico = ref(null);
const idStatus1 = ref(null);
const idStatus2 = ref(null);
const msgAlerta = ref(null);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'os_analitico_grupo', descricao: 'Grupo de Equipamento'},
    {id: 'os_analitico_regiao', descricao: 'Região'},
    {id: 'os_analitico_servico', descricao: 'Tipo de Serviço'},
]);
const opcaoSelecionada = ref('os_analitico_grupo');

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        let informacoes = `Período: ${Funcoes.formatDateFromJson(dateRange.value.startDate)} a ${Funcoes.formatDateFromJson(dateRange.value.endDate)}`;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            idequipamento: idEquipamento.value,
            idequipamentogrupo: idGrupo.value,
            idlocalidade: idLocalidade.value,
            idregiao: idRegiao.value,
            idservico: idServico.value,
            informacoes,
            intp1: idStatus1.value,
            intp2: idStatus2.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>